"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TGImageUploadFieldWeb = void 0;
// @ts-nocheck
const react_1 = __importDefault(require("react"));
const TGMediaFileFieldWeb_1 = __importDefault(require("./TGMediaFileFieldWeb"));
const defaultProps = {
    captureLabel: 'File Capture Type',
    fileUploadLabel: 'File upload',
    deviceUploadLabel: 'Use Device Camera',
    dragLabel: 'Drag and Drop files here',
    allowedTypes: [],
    limitInMb: 50,
    captureFileLabel: 'CAPTURE IMAGE',
    mediaType: 'file',
};
const TGImageUploadFieldWeb = props => {
    return react_1.default.createElement(TGMediaFileFieldWeb_1.default, Object.assign({}, defaultProps, props, { type: 'fileupload' }));
};
exports.TGImageUploadFieldWeb = TGImageUploadFieldWeb;
exports.default = exports.TGImageUploadFieldWeb;
//# sourceMappingURL=TGFileUploadFieldWeb.js.map